export const getNamePanoramic = (name) => {
  if (name) {
    const arr = name.split('.');
    return arr[0];
  }
};
